import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  card: {
    marginTop: theme.spacing(1),
    color: theme.palette.grey[200],
  },
  title: {
    fontWeight: 500,
  },
}));

export default useStyles;
